// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cf311286","455":"be69b7c6"}[chunkId] + ".chunk.js";
};